import { Toast } from "primereact/toast";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootStateType } from "./storeRedux/store";
import { setToast } from "./storeRedux/slices/toast";
import { Navigate, Route, Routes } from "react-router-dom";
import { FrontLayout } from "./layout/frontend/layout";
import { routes } from "./routes";
import { PageNotFound } from "./views/page-not-found";
import { Home } from "views/home/home";
import { Auth } from "views/auth/auth";
import { useLangContext } from "context/Lang";
import { setDirection } from "storeRedux/slices/configSlice";
import { Logout } from "views/auth/logout";
import { ViewDashboard } from "views/dashboard/ViewDashboard";
import { Editor } from "views/editor/editor";
import { DialogModal } from "components/dialog-modal/dialog-modal";
import { setToggaleLoginModal, setUser } from "storeRedux/slices/authSlice";
import { Login } from "views/auth/login/login";
import { MapEditor } from "views/map-editor/map-editor";

export const App = () => {


    const config = useSelector((state: RootStateType) => state.config);
    const toast = useSelector((state: RootStateType) => state.toast);
    const {isLoginModalOpen} = useSelector((state:RootStateType)=>state.auth);
    const { direction } = { ...config }



    const { lang,gW } = useLangContext();

    const dispatch = useDispatch();

    const toastRef = useRef<Toast>(null);

    useEffect(() => {
        if (toast.summary || toast.detail) {
            toastRef.current?.show({
                detail: toast.detail,
                severity: toast.severity,
                summary: toast.summary,
                life: 3000,
            });
            dispatch(setToast({ summary: undefined, detail: undefined }));
        }
    }, [toast])


    useEffect(() => {
        if (lang === "ar" && direction !== "rtl") {
            document.body.dir = "rtl"

            dispatch(setDirection("rtl"))
        } else {
            document.body.dir = "ltr"
            dispatch(setDirection("ltr"))
        }
    }, [lang]);

    return <div >
        <Routes>
            <Route element={<FrontLayout />}>

                <Route path="*" element={<Navigate to={routes.pageNotFount} />} />
                <Route path={routes.pageNotFount} element={<PageNotFound />} />
                <Route path={routes.home} element={<Home />} />
                <Route path={routes.logout} element={<Logout />} />
                {/* {myRoutes.layout.map((route, index) => (<Route key={index} path={route.path} element={!viewLogo?route.element:<></>} />))} */}

                <Route path={routes.auth} element={<Auth />} >
                    <Route path={routes.authProcess} element={<></>} />
                </Route>
            </Route>
            <Route element={<Auth />} >
                <Route path={routes.dashboard} element={<ViewDashboard />} >
                    <Route path={routes.dashboardRroute} element={<></>} />
                    <Route path={routes.dashboardRroutePage} element={<></>} />
                </Route>
                <Route path={routes.editor} element={<div className=" w-screen h-screen " ><Editor /></div>} />
                <Route path={routes.mapEditor} element={<div className=" w-screen h-screen " ><MapEditor /></div>} />
            </Route>





        </Routes>
        <Toast style={{zIndex:100000}}   position={direction === "ltr" ? "top-left" : "top-right"} ref={toastRef} />
        
        <DialogModal
            onClose={()=>{
                dispatch(setUser({}))
                dispatch(setToggaleLoginModal())
            }}
            isOpen={isLoginModalOpen||false}
            title={gW("invalid-token")}

        >
            
                {isLoginModalOpen&&<Login
                    className=""
                    onLogin={()=>{
                        dispatch(setToggaleLoginModal())
                    }}
                    doNatRoute={true}
                />}
            
        </DialogModal>
    </div>
};